
import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import { namespace, Getter, Action } from "vuex-class"

import vSelect from "vue-select"

import { Field, CaseDetails, User, CaseUser, Team } from "@/types"

import api from "@/services/api"

const setup = namespace("setup")

@Component({
	components: {
		"v-select": vSelect
	}
})
export default class UserRoleSetup extends Vue {
	@Prop()
	value: any;

	@setup.State teams!: Team[];

	get subroles (): any[] {
		return (this.value && this.value.subroles) ? this.value.subroles : []
	}

	mounted () {
		if (!this.value) {
			this.$emit("input", {
				hasSubroles: false,
				subroles: []
			})
		} else if (this.value.hasSubroles === undefined) {
			this.raiseChange({ hasSubroles: false, subroles: [] })
		} else if (this.value.subroles === undefined) {
			this.raiseChange({ subroles: [] })
		}
	}

	raiseChange (changedData: any) {
		// Clear the relevant data depending on if subroles is enabled
		if (!this.value.hasSubroles && this.value.subroles) {
			this.value.subroles = []
		} else {
			delete this.value.isSingleUser
			delete this.value.makeAssignee
			delete this.value.allowTimeTracking
		}

		if (!changedData.isSingleUser || changedData.allowExternalUsers) {
			this.value.makeAssignee = false
		}

		this.$emit("input", {
			...this.value,
			...changedData
		})
	}

	addSubRole () {
		this.value.subroles.push({
			title: "",
			isSingleUser: false,
			makeAssignee: false,
			allowTimeTracking: false
		})
	}

	removeSubRole (role: any) {
		this.value.subroles.remove(role)
	}

	singleUserSet (value : any, role: any) {
		if (!value) { role.makeAssignee = false }
	}

	setTeams (teams: string[]) {
		this.raiseChange({
			teams
		})
	}
}

